import { render, staticRenderFns } from "./LegalRepresentativeEditor.vue?vue&type=template&id=6ad64ced&scoped=true"
import script from "./LegalRepresentativeEditor.vue?vue&type=script&lang=js"
export * from "./LegalRepresentativeEditor.vue?vue&type=script&lang=js"
import style0 from "./LegalRepresentativeEditor.vue?vue&type=style&index=0&id=6ad64ced&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad64ced",
  null
  
)

export default component.exports